import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@scale/scaleui';

interface SelectSessionButtonProps {
  title: string;
  selected: boolean;
  onClick: () => void;
  elapsed?: boolean;
}

export const SelectSessionButton = ({
  title,
  selected,
  onClick,
  elapsed,
}: SelectSessionButtonProps) => {
  return (
    <div
      className={twMerge(
        'w-[180px] border-b border-neutral-200 p-4 hover:bg-neutral-100 cursor-pointer',
        elapsed && 'bg-neutral-200',
        selected && 'bg-primary-100 hover:bg-primary-200',
      )}
      onClick={onClick}
    >
      <Typography.Paragraph2>{title}</Typography.Paragraph2>
    </div>
  );
};
